'use strict';


import { TilesPluginCore } from './TilesPluginCore';
import { Buildings, threeJsVariables } from '../../../../settings';
import { Group, Vector3 } from 'three';
import { createBuildingCSSLabel, hideBuildingLabels, showBuildingLabels } from '../../building-switch/buildingLabels';

export class BuildingLabelsPlugin extends TilesPluginCore{
	constructor (panorama) {
		super('BuildingLabelsPlugin');
	
		this.panorama = panorama;
		this.labels = [];
		this.hoverLabel = null;
		this.#createLabels();
	}
	
	#getBuildings() {
		return new Promise(resolve => {
			const interval = setInterval(() => {
				if (Buildings.getBuildingsArray().length) {
					clearInterval(interval);
					resolve(Buildings.getBuildingsArray())
				}
			},300);
		});
	}
	
	#createLabels() {
		this.#getBuildings()
			.then(buildings => {
				this.labels = [];
				let buildingsLabelsGroup = threeJsVariables.scene.getObjectByName('buildingsLabelsGroup');
				if (buildingsLabelsGroup) {
					while (buildingsLabelsGroup.children.length) {
						buildingsLabelsGroup.children[0].removeFromParent();
					}
				} else {
					buildingsLabelsGroup = new Group();
					buildingsLabelsGroup.name = 'buildingsLabelsGroup';
					threeJsVariables.scene.add(buildingsLabelsGroup);
				}
				
				const mapping = this.panorama.config.mapping;
				const zoomRule = config.threejs.label.size || 0.6;
				
				
				buildings.forEach(building => {
					const mappingBuilding = mapping.find(b => b.buildingEngineId === building.name);
					if (mappingBuilding && mappingBuilding.label) {
						const bundleData = threeJsVariables.bundleConfig?.buildingLabels[building.name];
						const label = createBuildingCSSLabel(building);
						label.name = `labelTower-${building.info.labelName}`;
						label.userData.zoom = zoomRule;
						label.userData.buildingEngineId = building.name;
						label.position.fromArray(mappingBuilding.label);
						if (bundleData) {
							label.center.fromArray(bundleData.pivot);
						}
						this.labels.push(label);
						buildingsLabelsGroup.add(label)
					}
				});
			});
	}
	
	disable () {
		this.labels.forEach(label => label.removeFromParent());
	}
	
	enable () {
		const parent = threeJsVariables.scene.getObjectByName('buildingsLabelsGroup');
		this.labels.forEach(label => parent.add(label));
		setTimeout(() => showBuildingLabels(),0);
	}
	
	hover(buildingId) {
		this.hoverOut();
		const label = this.labels.find(label => label.userData.buildingEngineId === buildingId);
		if (label) {
			label.element.querySelector('.building-labels_wrapper')?.classList.add('building__hovered');
			this.hoverLabel = label;
		}
	}
	
	hoverOut() {
		if (this.hoverLabel) {
			this.hoverLabel.element.querySelector('.building-labels_wrapper')?.classList.remove('building__hovered');
		}
		this.hoverLabel = null;
	}
	
	dispose () {
		this.labels.forEach(label => label.removeFromParent());
		this.labels = [];
		this.hoverLabel = null;
	}
	
}
